import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class ModuloApi {
    
    static activar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/modulo/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/modulo/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    static borrarMC(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/modulo/borrarmc/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getModuloList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
         let combos="";
         if(filtrosCombo){
             for (var comboValue in filtrosCombo) {
                  //if(filtrosCombo[comboValue]!="" && !isNaN(filtrosCombo[comboValue])){                      
                      combos+="&"+comboValue+"="+filtrosCombo[comboValue];
                  //}
            }
             
        }
        
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos+combos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    static getModulosList(idCurso, token ) {
        
        return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/modulo/modulos/"+idCurso,
            statusCode: {
                401: function() {
                   // Only if your server returns a 403 status code can it come in this block. :-)					
                    window.location = getLocacion()+'/login';
                }
            }
		});
      
	}
    
    
    static getModuloConfig(id,idCurso, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo/"+id+"/"+idCurso,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static getModulo(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(modulo, token ) {          
      let moduloEnvio = Object.assign({}, modulo);
		let comando="POST";
		if (moduloEnvio.id > 0) {
			comando="PUT";			
		} 
		moduloEnvio=JSON.stringify(moduloEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: moduloEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    
    static saveConfig(modulo, token ) {          
      let moduloEnvio = Object.assign({}, modulo);
		let comando="POST";
		if (moduloEnvio.id > 0) {
			comando="PUT";			
		} 
		moduloEnvio=JSON.stringify(moduloEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo/config",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: moduloEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static saveModuloCursoOrden(modulos, token ) {          
      let moduloEnvio = Object.assign([], modulos);
		let envio={
			"cursoModuloListUI":moduloEnvio
		};   
        
        let comando="PUT";			
		envio=JSON.stringify(envio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo/orden",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: envio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static saveModuloContenidoOrden(contenido, token ) {          
      let moduloEnvio = Object.assign([], contenido);
		let envio={
			"moduloContenidoListUI":moduloEnvio
		};   
        
        let comando="PUT";			
		envio=JSON.stringify(envio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo/contenidoorden",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: envio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    static getModuloCombo(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/modulo/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}